import { render } from "./FeedbackView.vue?vue&type=template&id=33c8a802&scoped=true"
import script from "./FeedbackView.vue?vue&type=script&lang=js"
export * from "./FeedbackView.vue?vue&type=script&lang=js"

import "./FeedbackView.vue?vue&type=style&index=0&id=33c8a802&scoped=true&lang=css"

import exportComponent from "/Users/matsushitamasaya/webex/setouchi-webapp2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c8a802"]])

export default __exports__